import type { InjectionKey, Ref } from 'vue'

export type ModuleLocaleContext = {
  baseLocale: Ref<string>
}

export const ModuleLocaleKey: InjectionKey<ModuleLocaleContext> = Symbol('ModuleLocaleContext')
